export default __webpack_public_path__ + "static/media/440px-EBay_logo.9445bc96.png";